import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { DrilldownBar } from '../components/admin/DrilldownBar';
import { CommissionsWorkspace } from '../components/CommissionsWorkspace';
import { officers } from '../data/officers';
interface OfficerCommissionsProps {
  simulateLoadError: boolean;
}

/** Admin drill-down into one person's commission statement. */
export function OfficerCommissions({
  simulateLoadError
}: OfficerCommissionsProps) {
  const {
    officerId
  } = useParams();
  const officer = officers.find(item => item.id === officerId);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [officerId]);
  if (!officer) return <Navigate to="/" replace data-id="element-576" data-mp="39pes2kkfvvuw" />;
  return <>
      <DrilldownBar officer={officer} data-id="element-577" data-mp="39omyffaek879" />
      <CommissionsWorkspace key={officer.id} officerId={officer.id} isAdmin simulateLoadError={simulateLoadError} data-id="element-578" data-mp="39nlj2ymcszjq" />
    </>;
}